import { CustomizableAssets } from '@shared/shared/interfaces/custom-assets.interfaces';
import * as customAssetActions from '../actions/custom-assets.actions';

export interface CustomAssetsState extends CustomizableAssets {
  loading: boolean;
  loaded: boolean;
}

export const initialState: CustomAssetsState = {
  booking_confirmation_other_hero: [],
  core_booking_confirmation_hero: [],
  core_booking_confirmation_value_proposition: [],
  custom_footer_image_overlay: null,
  dining_hero: [],
  dining_value_proposition: [],
  entertainment_artist_value_proposition: [],
  entertainment_hero: [],
  entertainment_value_proposition: [],
  events_hero: [],
  events_value_proposition: [],
  favicon_icon: null,
  global_travel_value_proposition: [],
  homepage_hero: [],
  homepage_value_proposition: [],
  homepage_video_popup: [],
  inspiration_module_hero_image: [],
  logged_out_landing_usp_image_for_dining: null,
  logged_out_landing_usp_image_for_entertainment: null,
  logged_out_landing_usp_image_for_events: null,
  logged_out_landing_usp_image_for_hotels: null,
  logged_out_landing_usp_image_for_inspiration: null,
  logged_out_landing_usp_image_for_main: null,
  logged_out_landing_usp_image_for_offers: null,
  offers_hero: [],
  offers_value_proposition: [],
  onboarding_tutorial_artist_slide: null,
  onboarding_tutorial_benefits_slide: null,
  onboarding_tutorial_dining_slide: null,
  onboarding_tutorial_entertainment_slide: null,
  onboarding_tutorial_event_slide: null,
  onboarding_tutorial_landing_slide: null,
  onboarding_tutorial_marketing_opt_in_slide: null,
  onboarding_tutorial_partners_slide: null,
  onboarding_tutorial_travel_slide: null,
  partners_hero_image: null,
  prelogin_hero: [],
  prelogin_top_brands: [],
  prelogin_value_proposition: [],
  site_logo: null,
  travel_details_value_proposition: [],
  travel_hero: [],
  travel_traveler_details: [],
  travel_value_proposition: [],
  loaded: false,
  loading: false,
  selector_and_log_in_background_image: null,
  mtls_homepage_carousel: [],
  mtls_bottom_hero_image_background: null,
  member_events_value_proposition: [],
  non_mtls_pre_login_home_hero_image: null,
  non_mtls_pre_login_home_mid_page_hero_image: null,
  non_mtls_pre_login_home_sub_hero_carousel: [],
  non_mtls_pre_login_home_value_proposition: [],
  non_mtls_pre_login_home_our_mentions: [],
  prelogin_benefits_hero_image: null,
  prelogin_benefits_sub_hero_image: null,
  prelogin_inspiration_hero_image: null,
  non_mtls_pre_footer_hero_image: null,
  non_mtls_pre_login_home_travel: null,
  non_mtls_pre_login_home_shopping: null,
  non_mtls_pre_login_home_dining: null,
  non_mtls_pre_login_home_entertainment: null,
};

export function reducer(
  state: CustomAssetsState = initialState,
  action: customAssetActions.CustomAssetsActions
): CustomAssetsState {
  switch (action.type) {
    case customAssetActions.GET_CUSTOM_ASSETS:
      return {
        ...state,
        loading: true,
      };
    case customAssetActions.GET_CUSTOM_ASSETS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    case customAssetActions.GET_CUSTOM_ASSETS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
        loaded: true,
      };
    default:
      return state;
  }
}
